import React, { useContext, useState } from 'react';
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import { LanguageProviderContext } from '@/providers/LanguageProvider';

interface ConfirmActionModalProps {
  onConfirmAction?: () => void;
  onClick?: () => void;
  cancelFunction?: () => void;
  triggerClassName?: string;
  title?: string;
  description?: string;
  content?: React.ReactNode;
  actionButtonVariant?: "link" | "default" | "destructive" | "outline" | "secondary" | "ghost"
  openModalButtonVariant?:"link" | "default" | "destructive" | "outline" | "secondary" | "ghost"
  size?: "default" | "sm" | "lg" | "icon";
  buttonLabel: string;
  iconButton?: React.ReactNode;
}

const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({ onConfirmAction, onClick, cancelFunction, triggerClassName, title, description, actionButtonVariant, buttonLabel, iconButton, size, openModalButtonVariant }) => {
  const { translator } = useContext(LanguageProviderContext);
  const [open, setOpen] = useState(false);

  const handleConfirm = () => {
    onConfirmAction();
    setOpen(false);
  };

  const handleCancel = () => {
    if (cancelFunction) {
      cancelFunction();
    }
    setOpen(false);
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          size={size}
          variant={openModalButtonVariant || 'ghost'}
          className={triggerClassName}
          onClick={onClick}
        >
          {iconButton || <Trash2 className="h-3 w-3" />}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>
            {description}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={handleCancel}>
            {translator('Global.cancel')}
          </Button>
          <Button variant={actionButtonVariant} onClick={handleConfirm}>
            {buttonLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmActionModal;
